import { request, Response } from '../utils';
import { Session, File } from '../types';

export const listFiles = (body: {
  session: Session;
}): Response<{
  files: Array<File>;
}> => request('list-files', body);
